/** Auth endpoints (`/auth`). Stateful session handling lives in AuthContext. */
import { apiClient, postData } from "../lib/apiClient";
import { ApiEnvelope } from "../types/api";
import { AuthSession, User } from "../types/models";

export interface LoginInput {
  email: string;
  password: string;
}

export interface RegisterInput {
  email: string;
  password: string;
  fullName: string;
  phone?: string;
  companyName: string;
  contactPerson?: string;
  address?: string;
  city?: string;
  taxNumber?: string;
}

export interface ChangePasswordInput {
  currentPassword: string;
  newPassword: string;
}

export const authApi = {
  login: (input: LoginInput) => postData<AuthSession>("/auth/login", input),

  register: (input: RegisterInput) =>
    postData<AuthSession>("/auth/register", input),

  /** Returns the current user, hydrated with `client`/`staff` relations. */
  me: () => apiClient.get<ApiEnvelope<User>>("/auth/me").then((r) => r.data.data),

  logout: () => postData<null>("/auth/logout"),

  logoutAll: () => postData<null>("/auth/logout-all"),

  changePassword: (input: ChangePasswordInput) =>
    postData<null>("/auth/change-password", input),
};
